import React from 'react';
import { FaTimesCircle } from 'react-icons/fa/index';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface Props {
    errorMessage?: string
    //Any other props:
    [x:string]: any
}

const Error : React.SFC<Props> = (props) => {
    if(props.errorMessage) {
        const tooltip = <Tooltip id={'tooltip-error'} >{props.errorMessage}</Tooltip>

        return (
            <OverlayTrigger
                key={'error'}
                placement={'bottom'}
                overlay={tooltip}
            >
                <FaTimesCircle className="asyncstatusicon-error shake" />
            </OverlayTrigger>);
    }
    else {
        return <FaTimesCircle className="asyncstatusicon-error shake" />;
    }
}

export default Error